<template>
  <div id="copyright">
    <div class="line"></div>
    <div>
      <p>Copyright © 2000-2024 广州市台资企业协会版权信息</p>
      <p><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20023961号-1</a ></p>
    </div>
    <div style="height: 30px;"></div> 
  </div>
</template>
<script>
export default {
  name: "CopyrightLayout",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
#copyright{
  width: 1200px;
  height: 100px;
  margin:0 auto;
}
.line{
  height: 1px;
  width: 1200px;
  border-top: 1px solid #D8D8D8;
  margin:0 auto;
}
#copyright p{
  margin: 0 auto;
  font-family: MiSans;
  font-size: 18px;
  font-weight: normal;
  line-height: 32px;
  color: #3D3D3D;
  text-align: center;
  margin:0 auto;
  display: block;
  width: 1200px;
  margin-top: 34px;
}
</style>